import { Button } from "@mui/material";
import { useCurrentUser } from "../../hooks/useCurrentUser";

export default function SidebarAuthSection() {
    const { isAuthenticated, signIn, signOut } = useCurrentUser();

  if (isAuthenticated) {
    return (
      <Button
        onClick={signOut}
        sx={(theme) => ({
          color: theme.palette.secondary.main,
          textTransform: "uppercase",

          ...theme.applyStyles("dark", {
            color: theme.palette.primary.main,
          }),
        })}
      >
        Sign out
      </Button>
    );
  }

  return (
    <Button onClick={signIn} variant="contained">
      Sign in
    </Button>
  );
}